import {
    DELETE_CURRENCY_FAILED,
  DELETE_CURRENCY_SUCCESS,
  DELETE_CURRENCY_LOADING,
    } from "../types";
    
    const initialState = {
      loading: false,
      error: null,
      status: null,
      message:null ,
    };
    
    export const deleteCurrencyReducer = (
      state = initialState,
      action: { type: any; loading:boolean , payload: any, error: any, status: string , message : string  }
    ) => {
      switch (action.type) {
        case DELETE_CURRENCY_LOADING:
          return {
            ...state,
            loading: action.loading,
          };
        case DELETE_CURRENCY_SUCCESS:
         //
          return {
            ...state,
            loading: false,
            status: action.payload,
            message:action.payload ,
            error: null,
          };
        case DELETE_CURRENCY_FAILED:
          return {
            ...state,
            loading: false,
            status: null,
            message:null , 
            error: action.error,
          };
          
        default:
          return state;
      }
    };
    